import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SURVEYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SurveyType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SurveyType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const SURVEYTYPE_CONFIG = {
  entityName: 'SurveyType',
  localizationKey: 'Planning::Entity.SurveyType',
  fields: SURVEYTYPE_FIELDS,
  permission: 'PlanningEnvironment.SurveyTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
